import { httpsCallable } from "firebase/functions";
import { collection, getDocs, orderBy, query, updateDoc, doc, where, limit } from "firebase/firestore";
import { ACTIONS, writeLog } from "./auditService";
import { db, functions } from "./firebase";

export async function listUsers() {
  const q = query(collection(db, "users"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ uid: d.id, ...d.data() }));
}

export async function revokeAdmin(uid, actor, targetUser = null) {
  if (!uid) {
    const error = new Error("Missing user id");
    error.code = "user/missing-uid";
    throw error;
  }
  if (actor?.uid && uid === actor.uid) {
    const error = new Error("You cannot revoke your own admin role");
    error.code = "user/cannot-revoke-self";
    throw error;
  }

  const adminsSnap = await getDocs(query(collection(db, "users"), where("role", "==", "admin"), limit(2)));
  const isLastAdmin = adminsSnap.size === 1 && adminsSnap.docs[0]?.id === uid;
  if (isLastAdmin) {
    const error = new Error("Cannot revoke the last admin account");
    error.code = "user/cannot-revoke-last-admin";
    throw error;
  }

  await updateDoc(doc(db, "users", uid), { role: "standard" });
  await writeLog(actor, ACTIONS.REJECT_ACCESS, "user", uid, `Admin revoked: ${targetUser?.displayName || uid}`, {
    previousRole: "admin",
    role: "standard",
    reason: "manual_admin_revocation",
  });
}

/**
 * Permanently delete a user (Auth + Firestore + related data). Server verifies admin role and admin access code.
 */
export async function deleteUserByAdmin(targetUid, adminCode) {
  if (!targetUid || !String(adminCode || "").trim()) {
    const error = new Error("Target user and admin access code are required");
    error.code = "user/missing-delete-input";
    throw error;
  }
  const trimmed = String(adminCode).trim();
  const callable = httpsCallable(functions, "adminDeleteUser");
  const res = await callable({ targetUid, adminCode: trimmed });
  return res.data;
}

export async function getUserCount() {
  const snap = await getDocs(collection(db, "users"));
  return snap.size;
}
